import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";

export const downloadSurveyPDF = async (setGlobalSpinner) => {
  setGlobalSpinner(true); // Show spinner

  try {
    const doc = new jsPDF("p", "px", "a4");
    const elements = ["form"];
    const padding = 10;

    let top = 15;

    for (const elementId of elements) {
      const el = document.getElementById(elementId);
      if (!el) continue;

      const imgData = await htmlToImage.toJpeg(el, {
        backgroundColor: "#FFFFFF",
        quality: 3,
      });

      let elHeight = el.offsetHeight;
      let elWidth = el.offsetWidth;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      if (elWidth > pageWidth) {
        const ratio = pageWidth / elWidth;
        elHeight = elHeight * ratio - padding;
        elWidth = elWidth * ratio - padding;
      }

      doc.addImage(imgData, "JPEG", padding, top, elWidth, elHeight);
      top += elHeight;

      let heightLeft = elHeight - pageHeight;
      while (heightLeft > 0) {
        doc.addPage();
        top = -heightLeft;
        doc.addImage(imgData, "JPEG", padding, top, elWidth, elHeight);
        heightLeft -= pageHeight;
      }
    }

    doc.save("patient_summary.pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    setGlobalSpinner(false); // Hide spinner
  }
};
